import * as tslib_1 from "tslib";
import { jsonMember, jsonObject } from "typedjson";
import * as moment from "moment";
let DxControlPointPattern = class DxControlPointPattern {
    get duration() {
        return moment.duration({
            day: this.dayPartOfDuration,
            hour: this.hourPartOfDuration,
        }).format('M __, d __, h __', { trim: 'both', stopTrim: 'd' });
    }
};
tslib_1.__decorate([
    jsonMember({ constructor: Number, isRequired: true }),
    tslib_1.__metadata("design:type", Number)
], DxControlPointPattern.prototype, "chainPatternId", void 0);
tslib_1.__decorate([
    jsonMember({ constructor: Number, isRequired: true }),
    tslib_1.__metadata("design:type", Number)
], DxControlPointPattern.prototype, "dayPartOfDuration", void 0);
tslib_1.__decorate([
    jsonMember({ constructor: Number, isRequired: true }),
    tslib_1.__metadata("design:type", Number)
], DxControlPointPattern.prototype, "hourPartOfDuration", void 0);
tslib_1.__decorate([
    jsonMember({ constructor: Number, isRequired: true }),
    tslib_1.__metadata("design:type", Number)
], DxControlPointPattern.prototype, "id", void 0);
tslib_1.__decorate([
    jsonMember({ constructor: String, isRequired: true }),
    tslib_1.__metadata("design:type", String)
], DxControlPointPattern.prototype, "ident", void 0);
tslib_1.__decorate([
    jsonMember({ constructor: String, isRequired: true }),
    tslib_1.__metadata("design:type", String)
], DxControlPointPattern.prototype, "name", void 0);
tslib_1.__decorate([
    jsonMember({ constructor: Number, isRequired: true }),
    tslib_1.__metadata("design:type", Number)
], DxControlPointPattern.prototype, "ord", void 0);
tslib_1.__decorate([
    jsonMember({ constructor: Number, isRequired: false }),
    tslib_1.__metadata("design:type", Number)
], DxControlPointPattern.prototype, "prevId", void 0);
tslib_1.__decorate([
    jsonMember({ constructor: Date, isRequired: true }),
    tslib_1.__metadata("design:type", Date)
], DxControlPointPattern.prototype, "validityPeriodEndDate", void 0);
tslib_1.__decorate([
    jsonMember({ constructor: Date, isRequired: true }),
    tslib_1.__metadata("design:type", Date)
], DxControlPointPattern.prototype, "validityPeriodStartDate", void 0);
DxControlPointPattern = tslib_1.__decorate([
    jsonObject()
], DxControlPointPattern);
export { DxControlPointPattern };
